<template>
<div class="col-12">
<Toolbar>
<template #start>
<h4 class="text-primary mb-2 mt-2 font-medium">Sütun Seçenekleri</h4>
</template>
<template #end>
<template v-if="!adding_new">
<div class="hide_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm" label="Yeni Ekle" icon="pi pi-plus" @click="addNew" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm"  icon="pi pi-plus" @click="addNew" /></div>
	
</template>


</template>
</Toolbar>


<template v-if="adding_new">
<div class="grid">
<div class="col-12">

<ClickEditInputText  title="İsim" :value="newitem.name" valkey="name" @dataChanged="newitemChanged" />
<ClickEditNumber title="Puan" :value="newitem.points" valkey="points" @dataChanged="newitemChanged"  :steps="0.01"  />

<template v-for="translation in newitem.translations">
	<ClickEditInputText  :title="translation.language.name+' çeviri'" :value="translation.translation" valkey="name" @dataChanged="newitemTranslationChanged($event,translation.id)" />
</template>

<div class="flex justify-content-end flex-wrap mt-3">
 <Button label="İptal" class=" p-button-danger p-button-outlined  p-button-sm mr-2"  @click="cancelNew"></Button>
 <Button label="Kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" @click="submitNew"></Button>
</div>

</div>

</div>
</template>



<draggable 
v-model="theoptions"
class="grid" 
@start="start" 
@end="end" 
@change="change"
handle=".handle"
v-bind="dragOptions"
item-key="id">
<template #item="{element}">
<div class="col-12 mt-4">	
	<div class="grid">
		<div class="col-1 handle">
		<span class="material-symbols-outlined">
		drag_handle
		</span>	
		</div>
		<template v-if="!element.is_editing">
			<div class="col-9">
			<p class="my-1">{{element.name}}</p>
			</div>
			<div class="col-2">
				<Button type="button"  icon="pi pi-pencil" @click="editItem(element.id)" class="p-button-primary p-button-outlined p-button-sm mr-2"   />
				<Button type="button"  icon="pi pi-times" @click="deleteOption(element.id)" class="p-button-danger p-button-outlined p-button-sm "  />
			</div>
		</template>


		<template v-if="element.is_editing">
			<div class="col-9 raised_item">
			<ClickEditInputText  title="İsim" :value="element.name" valkey="name" @dataChanged="itemChanged($event,element.id)" />
			<ClickEditNumber title="Puan" :value="element.points" valkey="points" @dataChanged="itemChanged($event,element.id)"  :steps="0.01"  />

			<template v-for="translation in element.translations">
				<ClickEditInputText  :title="translation.language.name+' çeviri'" :value="translation.translation" valkey="translation" @dataChanged="itemTranslationChanged($event,element.id,translation.id)" />
			</template>
			</div>
			<div class="col-2 ">
				<Button type="button"  icon="pi pi-check" @click="doneEditing(element.id)" class="p-button-success p-button-outlined p-button-sm mr-2"   />
			</div>


		</template>
		


	</div>
</div>


</template>
</draggable>
</div>
</template>

<script>
export default {

  name: 'ColumnOptions',
  props:["options","languages"],
  data () {
    return {
    	theoptions:[],
    	drag:false,
    	adding_new:false,
    	newitem:{
    		name:null,
    		points:0,
    		is_editing:false,
    		translations:[],
    	}
    }
  },
  computed:{
  	dragOptions() {
	      return {
	        animation: 200,
	        disabled: false,
	        ghostClass: "ghost"
	      };
    	},
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },
   },
   watch:{
   	deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
      	console.log("deletestate")
        this.getOptions()
      }
    }
   },
   mounted()
   {
   		this.adjustEditing(this.options)
   },
   methods:{
   	adjustEditing(options)
   	{   		
   		if(options && options.length)
   		{
   			for(let option of options)
		   	{   		
		   		option.is_editing = false
		   	}
		   	this.theoptions = options
   		}
	   	
   	},
   	async getOptions()
   	{
   		let options = await this.generalApiGetWithoutLoader("inputfieldcolumnoptions/"+this.$route.params.column_id)
   		this.adjustEditing(options)      
   	},
   	cancelNew()
   	{
   		this.adding_new = false
   		this.newitem ={name:null,points:0,translations:[],}
   	},
   	submitNew()
   	{
   		if(this.$route.params.column_id)
   		{
   			let formdata = new FormData()
   			formdata.append("column_id",this.$route.params.column_id)
   			formdata.append("option",JSON.stringify(this.newitem))
   			this.generalSubmission(formdata,"inputfieldcolumnoption/store",this.aftersubmitNew)
   		}
   		else
   		{
   			let newitem = this.sanitizeArray(this.newitem)
   			this.theoptions.push(newitem)
   			this.$emit("optionsUpdated",this.theoptions)
   			setTimeout(()=>{
   				this.cancelNew()
   			})
   		}
   		
   	},
   	aftersubmitNew(response)
   	{   		
   		this.cancelNew()
   		let option = response.data
   		option.is_editing = false
   		this.theoptions.push(option)
   	},
   	newitemTranslationChanged(data,id)
   	{
   		let ind = this.newitem.translations.findIndex((item)=>{return item.id == id})
   		this.newitem.translations[ind].translation = data.value
   	},
   	newitemChanged(data)
   	{
   		
   		this.newitem[data.key] = data.value
   		if(data.key=="name")
   		{
   			for(let translation of this.newitem.translations)
   			{
   				if(!translation.translation)
   				{
   					translation.translation = data.value
   				}
   			}
   		}
   	},
   	addNew()
   	{
   		for(let language of this.languages)
   		{
   			this.newitem.translations.push({id:Math.floor(Date.now() / 10),translation:null,language:language})
   		}   		
   		this.adding_new = true
   	},
   	end(event)
    { 
    	console.log(this.theoptions)
			this.drag = false
			let formdata = new FormData()
			formdata.append("list",JSON.stringify(this.theoptions))
			this.generalSubmission(formdata,"inputfieldcolumnoptions/"+this.$route.params.column_id,this.afterReorder)
			
		
    },
    afterReorder(response)
    {
    	console.log("afterReorder")
    	console.log(response.data)
    	this.theoptions = response.data
    },
    start(event)
    {
      this.drag = true
    },
    change(event)
    {
      //console.log(event)      
    },
    editItem(id)
    {
    	for(let option of this.theoptions)
    	{
    		option.is_editing = false
    	}
    	let ind = this.theoptions.findIndex((element)=>{return element.id == id})
    	this.theoptions[ind].is_editing = true
    },
    itemChanged(data,id)
    {
    	if(this.$route.params.column_id)
    	{
    		let formdata = new FormData()
   			formdata.append(data.key,data.value)
   			this.generalSubmission(formdata,"inputfieldcolumnoption/update/"+id,this.afterUpdate)
    	}
    	else
    	{
    		let ind = this.theoptions.findIndex((item)=>{return item.id == id})
    		this.theoptions[ind].value = data.value
   			this.$emit("optionsUpdated",this.theoptions)
    	}
    	
    },    
    itemTranslationChanged(data,id,translation_id)
    {
    	if(this.$route.params.column_id)
    	{
    		let formdata = new FormData()
   			formdata.append(data.key,data.value)
   			formdata.append("translation_id",translation_id)
   			this.generalSubmission(formdata,"inputfieldcolumnoption/update/"+id,this.afterUpdate)
    	}
    	else
    	{
    		let ind = this.theoptions.findIndex((item)=>{return item.id == id})
    		let trans_ind = this.theoptions[ind].translation.findIndxex((item)=>{return item.id == translation_id})
    		this.theoptions[ind].translations[trans_ind].translation = data.value
   			this.$emit("optionsUpdated",this.theoptions)
    	}
    	
    },
    afterUpdate(response)
    {
    	let ind = this.options.findIndex((item)=>{return item.id = response.data.id})
    	let option = response.data
    	option.is_editing = true
    	this.options[ind] = option
    },
    doneEditing(id)
    {
    	let ind = this.theoptions.findIndex((element)=>{return element.id == id})
    	this.theoptions[ind].is_editing = false
    },
    deleteOption(id)
    {
    	let formdata = new FormData()
   		//formdata.append("option_id",id)
   		this.generalSubmission(formdata,"inputfieldcolumnoption/delete/"+id,this.afterDeleteOption)    	
    },
    afterDeleteOption(response)
    {
    	this.theoptions = this.theoptions.filter(item=>item.id !== response.data)
    },
   },

}
</script>

<style lang="css" scoped>
	.handle{
		cursor: pointer;
	}
</style>